import Tooltip from '@material-ui/core/Tooltip';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListSubheader from '@material-ui/core/ListSubheader';
import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown';
import DoneIcon from '@material-ui/icons/Done';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        listHeading: {
            color: theme.palette.secondary.dark
        },
        input: {
            width: '100%'
        },
        menuItem: {
            fontSize: theme.typography.bodyFontSize
        },
        dropDownIcon: {
            borderLeft: theme.palette.border.main
        }
    }, globalStyles);
};

const NoLabelInput = withStyles(theme => ({
    root: {
        marginBottom: '6px',
        border: theme.palette.border.main,
        backgroundColor: 'white',
        borderRadius: '4px',
        '&:focus': {
            borderRadius: 4,
            backgroundColor: 'white',
            border: theme.palette.border.main
        },
    },
    input: {
        width: '242px',
        position: 'relative',
        fontSize: '14px',
        borderRadius: '4px',
        backgroundColor: 'white',
        padding: '9px 10px 9px 12px',
        '&:focus': {
            borderRadius: '4px',
            backgroundColor: 'white'
        },
    },
}))(InputBase);

const LabelledInput = withStyles(theme => ({
    root: {
        marginTop: theme.spacing(2.5),
        border: theme.palette.border.main,
        backgroundColor: 'white',
        fontSize: '14px',
        borderRadius: '4px',
        '&:focus': {
            borderRadius: 4,
            backgroundColor: 'white',
            border: theme.palette.border.main
        },
        '@media print': {
            display: 'none'
        }
    },
    input: {
        width: '242px',
        position: 'relative',
        fontSize: '14px',
        borderRadius: '4px',
        backgroundColor: 'white',
        padding: '9px 10px 9px 12px',
        '&:focus': {
            borderRadius: '4px',
            backgroundColor: 'white'
        },
    },
}))(InputBase);

class MenuSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.selected
        };
    }

    handleChange = event => {
        this.setState({ selected: event.target.value });
        this.props.handleChange(event.target.value);
    };

    render() {

        const { classes, options, hintWord, label, autoFocus, dataTest, hintPrefix, disabled, showValues, disable } = this.props;
        const { selected } = this.state;

        return (
            <FormControl className={classes.input} data-test={dataTest}>
                {label &&
                    <InputLabel className={classes.formSelectorLabel}>{label}</InputLabel>
                }
                <Select
                    data-test="menu-selector"
                    disabled={disabled}
                    classes={{
                        icon: classes.dropDownIcon
                    }}
                    className={classes.select}
                    style={{ width: '100%', lineHeight: '1em' }}
                    value={selected || ''}
                    onChange={this.handleChange}
                    IconComponent={ArrowIcon}
                    displayEmpty={true}
                    inputProps={{
                        className: classes.input
                    }}
                    MenuProps={{
                        "data-test": dataTest + "-list",
                        className: classes.menuItem
                    }}
                    input={label ?
                        <LabelledInput
                            inputProps={{ "data-test": "selected-value" }}
                            autoFocus={autoFocus} />
                        :
                        <NoLabelInput
                            inputProps={{ "data-test": "selected-value" }}
                            autoFocus={autoFocus} />}
                >
                    {hintWord && <MenuItem disabled value="">{hintPrefix && 'Select a'} {hintWord}&#160;</MenuItem>}
                    {options.map((option, index) =>
                        option.heading ?
                            index === options.length - 1 ?
                                null
                                :
                                <ListSubheader key={index} disableSticky className={classes.listHeading}>{option.label}</ListSubheader>
                            :
                            <MenuItem
                                data-test={dataTest + "-item-" + (typeof option.label === 'string' ? option.label : index)}
                                key={option.value + "-" + index}
                                disabled={option.disabled || disable === option.value}
                                className={classes.menuItem}
                                value={option.value}>
                                {showValues ?
                                    <Tooltip title={option.value}>
                                        <span style={{ width: '100%', marginRight: 6, ...(option.used) && { opacity: 0.5 } }}>
                                            {option.label}
                                        </span>
                                    </Tooltip>
                                    :
                                    <span style={{ width: '100%', marginRight: 6, ...(option.used) && { opacity: 0.5 } }}>
                                        {option.label}
                                    </span>
                                }
                                {option.used && selected !== option.value &&
                                    <ListItemSecondaryAction>
                                        <DoneIcon fontSize="small" />
                                    </ListItemSecondaryAction>
                                }
                            </MenuItem>)}
                </Select>
            </FormControl>
        );
    }
}

MenuSelector.defaultProps = {
    selected: "",
    autoFocus: false,
    showValues: false,
    hintPrefix: true,
    disabled: false,
    dataTest: "menu-selector"
};

MenuSelector.propTypes = {
    dataTest: PropTypes.string,
    disabled: PropTypes.bool,
    disable: PropTypes.string,
    autoFocus: PropTypes.bool,
    handleChange: PropTypes.func.isRequired,
    selected: PropTypes.string.isRequired,
    showValues: PropTypes.bool,
    label: PropTypes.string,
    hintWord: PropTypes.string,
    hintPrefix: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(MenuSelector);